export default __webpack_public_path__ + "static/media/chevronLeft.1a8cbca6.svg";